import React, { FC, useState } from 'react'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'
import routes from 'src/routes'
import Amplitude from 'src/utils/amplitudeHelper'
import { setPageTitle, setPreviousPage } from 'src/ducks/onDemand'
// import { DocumentViewer } from 'src/components/GlobalModals/DocumentViewer'
import { day1Videos } from '../categories'
import { StyledModal } from '../CategoryContent/styled'
import { Modal } from 'react-bootstrap'
import { Loader } from 'src/components/shared/Loader'

export const Day1Videos: FC<RouteComponentProps> = () => {
  const dispatch = useDispatch()
  
  useEffect(() => {
    dispatch(setPageTitle('Gallery'))
    dispatch(setPreviousPage(routes.lobby))
  }, [dispatch])

  const [currentVideo, setCurrentVideo] = useState(null)
  const [showModal, setShowModal] = useState(false)
  const [loading, setLoading] = useState(true)


  const handlePlayback = (item) => {
    setShowModal(true)
    setCurrentVideo(item)
    setLoading(true)
    // window.open(item.iframeUrl, '_blank')
    Amplitude.clickGalleryVideo(item.title)
  }

  const closeModal = () => {
    setCurrentVideo(null)
    setShowModal(false)
  }

  const handleIframeLoad = () => {
    setLoading(false)
  }

  return (
    <>
      <div className="grid-container">
        {day1Videos.length === 0 ? (
          <p>No videos available. Check back soon!</p>
        ) : (
          day1Videos.map((item) => (
            <div onClick={() => handlePlayback(item)} className="card-thumbnail" key={item.title}>
              <img src={item.thumbnail} width="100%" alt="thumbnail" />
              <span>{item.title}</span>
            </div>
          ))
        )}
      </div>
      {/* <DocumentViewer file={selectedTopic} setDocumentSelected={setSelectedTopic}/> */}
      <StyledModal show={showModal} onHide={closeModal} size="lg" aria-labelledby="vimeoPlayer" centered>
        <Modal.Header closeButton>
          <Modal.Title id="vimeoPlayer">
            <b>{currentVideo?.title}</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div id="vimeoContainer">
            {loading && <Loader loading={loading} />}
            <iframe onLoad={handleIframeLoad} src={currentVideo?.iframeUrl} frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" title={currentVideo?.title}></iframe>
          </div>
        </Modal.Body>
      </StyledModal>
    </>
  )
}
